import { Days } from "./Days";
export const getDayname = (dayId) => {
    const getday = Days.find((item) => item.id === dayId);
    return getday?.fullName;
  };